import SideNav from 'pages/studyOverview/components/SideNav';
import { TwoColumnScaffold, LeftColumn, RightColumn } from 'pages/studyOverview/components/TwoColumnScaffold';
import lodash from 'lodash';

import styles from './RoleManagement.scss';
import { connect } from 'react-redux';
import { loadHomePageV4Access } from '../../../common/features/predicates';

export const resourceTypes = Object.freeze({
    role: 'role',
});

const RoleManagement = (props) => {

    const roleLink = () => [{
        to: '/admin/role/study-role',
        title: `${props.complion4FlagEnabled ? 'Binder' : 'Study'} Roles`,
        type: resourceTypes.role,
    }];

    const sideNavLinks = roleLink();

    return (
        <TwoColumnScaffold className={styles.scaffold} data-cy="RoleManagement">
            <LeftColumn>
                <SideNav
                    links={sideNavLinks}
                    location={props.location}
                    activeIndex={() =>
                        lodash.findIndex(
                            sideNavLinks,
                            (link) => props.location.pathname.includes(link.to)
                        )
                    }
                />
            </LeftColumn>
            <RightColumn className={styles.rightColumn}>
                {props.children}
            </RightColumn>
        </TwoColumnScaffold>
    );
};
const mapStateToProps = state => ({
    complion4FlagEnabled: loadHomePageV4Access(state),

});

export default connect(mapStateToProps)(RoleManagement);